<template>
  <div class="progress-pic-uploader">
    <el-row :gutter="30" class="progress-pic">
	    <el-col :span="24">
	        <div class="checkin-pic-box">
	          <div class="checkin-pic-container">
	          	<div class="checkin-pic-title">Before Picture</div>
	          	<div class="pic-box" v-bind:style="{ backgroundImage: 'url(' + frontPicture + ')' }" >
	          		<el-button v-if="canUpload" type="default" size="small" @click="onUploadFrontClicked"><i class="fa fa-camera"> </i> Front</el-button>
	          	</div>
	          	<div class="pic-box" v-bind:style="{ backgroundImage: 'url(' + backPicture + ')' }">
	          		<el-button v-if="canUpload" type="default" size="small" @click="onUploadBackClicked"><i class="fa fa-camera"> </i> Back</el-button>
	          	</div>
	          	<div class="pic-box" v-bind:style="{ backgroundImage: 'url(' + sidePicture + ')' }">
	          		<el-button v-if="canUpload" type="default" size="small" @click="onUploadSideClicked"><i class="fa fa-camera"> </i> Side</el-button>
	          	</div>
	          	<div class="pic-box" v-bind:class="{'uploaded': frontNewsPicture}" v-bind:style="{ backgroundImage: 'url(' + frontNewsPicture + ')' }">
	          		<el-button v-if="canUpload" type="default" size="small" @click="onUploadFrontNewsClicked"><i class="fa fa-camera"> </i> Front w/Newspaper</el-button>
	          	</div>
	          </div>
	        </div>
	    </el-col>
    </el-row>
    <!-- <el-row :gutter="30" class="progress-pic">
	    <el-col :span="24">
	        <div class="checkin-story-box">
	          <div class="checkin-story-container">
	          	<div class="checkin-pic-title">Whats your motivation for wanting to transform?</div>
	          	<el-form style="min-height:120px;" :model="form">
		          	<el-form-item  label="">
				        <el-input rows="5" placeholder="Will be considered along with photo submissions to pick challenge winner. Deadline to submit is June 8th" type="textarea" v-model="form.story"></el-input>
				    </el-form-item>
				    <el-button :loading="savingData" style="float:right; height:40px; display:inline-block;"  @click="submitStory" type="primary">Save</el-button>
				</el-form>
	          </div>
	        </div>
	    </el-col>
    </el-row> -->
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'progress-pic',

  mounted: function(){
    var _this = this;
    var user = Parse.User.current();
    if(!user){
       this.$router.push('/login');
       return
    }
    user.fetch()
      .then(function(fetchedUser){
        console.log('Fetching')
        _this.form.story = fetchedUser.get('story');
        _this.frontPicture = fetchedUser.get('frontPicture');
        _this.sidePicture = fetchedUser.get('sidePicture');
        _this.backPicture = fetchedUser.get('backPicture');
        _this.frontNewsPicture = fetchedUser.get('frontNewsPicture');

        
      }).catch(function(err){
        console.log(err);
        alert('There was an error loading your data. Please contact support.')
      })

  },
  data () {
    return {
    	frontPicture:null,
    	frontNewsPicture:null,
    	backPicture:null,
    	sidePicture:null,

      frontAfterPicture:null,
    	frontNewsAfterPicture:null,
    	backAfterPicture:null,
    	sideAfterPicture:null,
    	form: {
    		story:null
    	},
    	imageSources:["local_file_system","imagesearch","facebook","instagram","dropbox"],
			savingData: false,
			canUpload: moment().diff('2019-05-12', 'hours') < 0
    }
  },
  methods:{
    submitStory:function(){
      var _this = this;
      var user = Parse.User.current();
      if(user){
        _this.savingData = true;
        user.set('story', this.form.story);
        user.save()
          .then(function(savedUser){
             _this.savingData = false;
              _this.$message({
                  type: 'success',
                  message: 'Your story has been saved!'
              });
          });
      }

    },
  	saveBeforePicture:function(imageField, imageUrl){
  		var _this = this;
  		var user = Parse.User.current();

  		user.set(imageField, imageUrl);
  		user.save()
  			.then(function(){
  				_this[imageField] = imageUrl;
  				_this.$message({
	              type: 'success',
	              message: 'Your image has been saved!'
	            });
  			})
  			.catch(function(err){
  				_this.$message({
	              type: 'error',
	              message: 'There was an error saving your image.'
	            });
  			})
  	},
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    onUploadFrontClicked:function openPicker() {
    	var _this = this;
	    window.fsClient.pick({
	      fromSources:_this.imageSources
	    }).then(function(response) {
	      // declare this function to handle response
	       if(response.filesUploaded.length){
         		_this.saveBeforePicture('frontPicture', response.filesUploaded[0].url)
        	}

	    });
	},
	onUploadBackClicked:function openPicker() {
		var _this = this;
	    window.fsClient.pick({
	      fromSources:_this.imageSources
	    }).then(function(response) {
	        // declare this function to handle response
	        if(response.filesUploaded.length){
         		_this.saveBeforePicture('backPicture', response.filesUploaded[0].url)
        	}
	    });
	},
	onUploadSideClicked:function openPicker() {
		var _this = this;
	    window.fsClient.pick({
	      fromSources:_this.imageSources
	    }).then(function(response) {
	      // declare this function to handle response
	        if(response.filesUploaded.length){
         		_this.saveBeforePicture('sidePicture', response.filesUploaded[0].url)
        	}
	    });
	},
	onUploadFrontNewsClicked:function openPicker() {
		var _this = this;
	    window.fsClient.pick({
	      fromSources:_this.imageSources
	    }).then(function(response) {
	      // declare this function to handle response
	        if(response.filesUploaded.length){
         		_this.saveBeforePicture('frontNewsPicture', response.filesUploaded[0].url);
        	}
	    });
    }
  }
}
</script>

<style>
  .checkin-pic-box {
    	background-color: #FFF;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    .checkin-pic-container {

      height: 280px;
      background-size: cover;

    }
    .checkin-story-box{
    	background-color: #FFF;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    	min-height: 180px;
    	    padding-bottom: 40px;
    }
    .checkin-story-container form{
    	padding: 20px;
    }
    .checkin-pic-container button {
      margin-top: 90px;
    }
    .checkin-pic-title {
      width: 100%;
      height: 50px;
      background-color: #F1F1F1;
      line-height: 50px;
      color: #999;
    }
    .checkin-pic-container .pic-box{
    	width: 25%;
    	height: 230px;
    	float: left;
    	box-sizing: border-box;
    	border-right: 1px solid #EEE;
      background-size:cover;
      background-position:top;
    }
    .checkin-pic-container .pic-box::last-of-type{
    	border:0;
    }
</style>
